
export default {
    name: "IconFlagIT",
}
